/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Testimonials_Subtitle_SuffixInputs */

const en_testimonials_subtitle_suffix = /** @type {(inputs: Testimonials_Subtitle_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Here's what they're saying:`)
};

const es_testimonials_subtitle_suffix = /** @type {(inputs: Testimonials_Subtitle_SuffixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esto es lo que dicen:`)
};

/**
* | output |
* | --- |
* | "Here's what they're saying:" |
*
* @param {Testimonials_Subtitle_SuffixInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const testimonials_subtitle_suffix = /** @type {((inputs?: Testimonials_Subtitle_SuffixInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Testimonials_Subtitle_SuffixInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_testimonials_subtitle_suffix(inputs)
	return en_testimonials_subtitle_suffix(inputs)
});